/**
 * 账号相关工具函数
 * 对标 tv-linux 项目 src/util/util.js 的 getAccountPicture
 */

import { getCookieAmend } from './apiUtils';

// 账号类型枚举
export enum AccountType {
  QQ = 'qq',
  WeChat = 'wx',
  Phone = 'phone',
  Facebook = 'fb',
  Line = 'li',
  Apple = 'apple',
  Google = 'google',
  Email = 'mail',
}

// main_login 值到 AccountType 的映射
// 根据实际 Cookie 中的值进行映射（支持多种格式）
const MAIN_LOGIN_MAP: Record<string, AccountType> = {
  qq: AccountType.QQ,
  wx: AccountType.WeChat,
  wechat: AccountType.WeChat,
  phone: AccountType.Phone, // 完整单词
  ph: AccountType.Phone, // 缩写
  fb: AccountType.Facebook,
  facebook: AccountType.Facebook,
  li: AccountType.Line,
  line: AccountType.Line,
  apple: AccountType.Apple,
  google: AccountType.Google,
  mail: AccountType.Email,
  email: AccountType.Email,
};

/**
 * 获取账号类型
 * 根据 Cookie 中的 main_login 字段判断
 */
export function getAccountType(): AccountType | null {
  const mainLogin = getCookieAmend('main_login');

  if (mainLogin && MAIN_LOGIN_MAP[mainLogin]) {
    return MAIN_LOGIN_MAP[mainLogin];
  }

  return null;
}

/**
 * 格式化日期
 * 将时间戳转换为 YYYY-MM-DD 格式
 */
export function formatDate(timestamp: number | string): string {
  if (!timestamp) return '';

  const date = new Date(typeof timestamp === 'string' ? parseInt(timestamp, 10) * 1000 : timestamp * 1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
